import axiosInstance from '@/app/api/axiosInstance'
import { PaginatedResponse, ListQueryParams } from '@/app/types/api'
import { VoucherResponse, VoucherCreate, VoucherUpdate } from '@/app/types/voucher'

const API_URL = '/debit-notes' // Specific endpoint for debit notes

export const listDebitNotes = async (
  params?: ListQueryParams
): Promise<PaginatedResponse<VoucherResponse>> => {
  const response = await axiosInstance.get<PaginatedResponse<VoucherResponse>>(API_URL, { params })
  return response.data
}

export const getDebitNote = async (id: number): Promise<VoucherResponse> => {
  const response = await axiosInstance.get<VoucherResponse>(`${API_URL}/${id}`)
  return response.data
}

// Create debit note with specified data
export const createDebitNote = async (data: VoucherCreate): Promise<VoucherResponse> => {
  // Convert total_amount to string for backend Decimal field
  const payload = {
    ...data,
    total_amount: String(data.total_amount)
  }
  const response = await axiosInstance.post<VoucherResponse>(API_URL, payload)
  response.data.total_amount = parseFloat(String(response.data.total_amount))
  return response.data
}

export const updateDebitNote = async (
  id: number,
  data: VoucherUpdate
): Promise<VoucherResponse> => {
  // Convert total_amount to string for backend Decimal field
  const payload = {
    ...data,
    total_amount: data.total_amount ? String(data.total_amount) : undefined
  }
  const response = await axiosInstance.patch<VoucherResponse>(`${API_URL}/${id}`, payload)
  response.data.total_amount = parseFloat(String(response.data.total_amount))
  return response.data
}

export const deleteDebitNote = async (id: number): Promise<void> => {
  await axiosInstance.delete(`${API_URL}/${id}`)
}
